/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 414);
/******/ })
/************************************************************************/
/******/ ({

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unicodeLen */
/* unused harmony export unicodeSlice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return domCountCharacters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return domSlice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return moveChildrenFromNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTextDom; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var DOMUtils = window.Liftoff.DOMUtils;


var isVariationSelector = function isVariationSelector(cstr) {
  if (cstr.length !== 1) {
    return false;
  }

  var code = cstr.charCodeAt(0);

  return 0xfe00 <= code && code <= 0xfe0f;
};

// Expects an array generated by [...str].
// Merges variation selectors into the previous character so that they do not occupy their own slot in the
// array.
// REFERENCE: See
// - https://blog.jonnew.com/posts/poo-dot-length-equals-two
// - https://codepoints.net/U+fe0f
// - https://codepoints.net/variation_selectors
var mergeVariationSelectors = function mergeVariationSelectors(unicodechars) {
  return unicodechars.reduce(function (acc, cstr) {
    if (acc.length > 0 && isVariationSelector(cstr)) {
      acc[acc.length - 1] += cstr;
    } else {
      acc.push(cstr);
    }
    return acc;
  }, []);
};

var unicodeLen = function unicodeLen(str) {
  return mergeVariationSelectors([].concat(_toConsumableArray(str))).length;
};

// Returns a string consisting of the leftmost 'n' Unicode characters of 'str'.
var unicodeSlice = function unicodeSlice(str, n) {
  return mergeVariationSelectors([].concat(_toConsumableArray(str))).slice(0, n).join("");
};

var domCountCharacters = function domCountCharacters(tree) {
  if (tree == null) {
    return 0;
  }

  if (tree.nodeType === Node.TEXT_NODE) {
    return unicodeLen(tree.nodeValue);
  }

  var numChars = 0;

  if (tree.hasChildNodes()) {
    [].concat(_toConsumableArray(tree.childNodes)).forEach(function (child) {
      numChars += domCountCharacters(child);
    });
  }

  return numChars;
};

// Return a copy of the tree, such that only the leftmost n characters in the text elements are preserved.
//
// The return value includes the new tree and the number of characters in it.
//
var domSlice = function domSlice(tree, n) {
  if (tree == null) {
    return { tree: null, charcount: 0 };
  }

  if (tree.nodeType === Node.TEXT_NODE) {
    var text = tree.nodeValue;
    var textLen = unicodeLen(text);
    var numCharsToPreserve = Math.min(n, textLen);
    var newText = unicodeSlice(text, numCharsToPreserve);

    return {
      tree: document.createTextNode(newText),
      charCount: numCharsToPreserve
    };
  }

  var ret = {
    tree: tree.cloneNode(false),
    charCount: 0
  };

  if (tree.hasChildNodes()) {
    var children = [].concat(_toConsumableArray(tree.childNodes));
    children.forEach(function (child) {
      var slicedChild = domSlice(child, n - ret.charCount);

      ret.charCount += slicedChild.charCount;

      if (slicedChild.charCount > 0 || child.textContent.length === 0) {
        ret.tree.appendChild(slicedChild.tree);
      }
    });
  }

  return ret;
};

// Removes any children of dstnode and moves the children of srcnode into dstnode.
var moveChildrenFromNode = function moveChildrenFromNode(dstnode, srcnode) {
  dstnode = DOMUtils.empty(dstnode);

  while (srcnode.firstChild) {
    var child = srcnode.removeChild(srcnode.firstChild);

    dstnode.appendChild(child);
  }

  return dstnode;
};

var getTextDom = function getTextDom(caption) {
  var div = document.createElement("div");
  div.innerHTML = caption;

  return div;
};

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(415);
module.exports = __webpack_require__(416);


/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_js_lib_text_anim__ = __webpack_require__(30);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    DOMUtils = _window$Liftoff.DOMUtils,
    Utils = _window$Liftoff.Utils;

// Duration (in ms) of gap between restarts of the typing effect.

var REPEAT_TYPING_EFFECT_EVERY = 3000;
// Duration (in ms) of gap between appearance of each letter during the typing effect.
var TYPING_INTERVAL = 50;

var TEXT_ALIGN_TO_FLEX = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
};

Component.register("text", function (_Component) {
  _inherits(Text, _Component);

  function Text(config) {
    _classCallCheck(this, Text);

    var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, config));

    Utils.assignWithDefaults(_this, {
      text: null,
      maxLines: null,
      interval: 3000,
      duration: 400,
      typingEffect: false,
      repeatTypingEffect: false,
      startTypingAfter: 0,
      style: {}
    }, _this.config);
    _this.maxLines = _this.maxLines === Infinity ? 0 : _this.maxLines;

    _this.animation = config.animation == null || config.animation === "none" ? null : config.animation;
    _this.switchers = (config.switchers || []).filter(function (switcher) {
      return switcher.replacements != null && switcher.replacements.length > 0;
    });
    _this.started = false;
    _this.on("set", function (_ref) {
      var val = _ref.val;

      _this.text = val;
      _this.layout(_this.parentNode);
    });
    return _this;
  }

  _createClass(Text, [{
    key: "layout",
    value: function layout(parentNode) {
      _get(Text.prototype.__proto__ || Object.getPrototypeOf(Text.prototype), "layout", this).call(this, parentNode);
      DOMUtils.empty(this.parentNode);
      this.el = document.createElement("div");
      this.el.classList.add("text");
      this.el.innerHTML = this.text;
      Object.assign(this.el.style, this.style);
      this.parentNode.appendChild(this.el);
      this.initSwitchers();
      this.resize();
    }
  }, {
    key: "initSwitchers",
    value: function initSwitchers() {
      var _this2 = this;

      this.switchers.forEach(function (switcher, i) {
        var regex = new RegExp(switcher.targetText, "g");
        _this2.el.innerHTML = _this2.el.innerHTML.replace(regex, "<div class=\"text-switcher text-switcher-" + i + "\"></div>");
        var switcherEls = _this2.el.querySelectorAll(".text-switcher-" + i);
        Array.from(switcherEls).forEach(function (switcherEl) {
          var width = -Infinity;
          switcher.replacements.forEach(function (replacement) {
            var replacementEl = document.createElement("div");
            replacementEl.style.whiteSpace = "nowrap";
            replacementEl.innerHTML = replacement.replacementText;
            replacementEl.style.webkitAnimationDelay = switcher.interval + "ms";
            replacementEl.style.webkitAnimationDuration = switcher.duration + "ms";
            switcherEl.appendChild(replacementEl);
            width = Math.max(width, replacementEl.getBoundingClientRect().width);
          });
          switcherEl.style.height = getComputedStyle(switcherEl).lineHeight;
          switcherEl.style.width = width + "px";
          // NOTE(oscar): "left" is used on older creatives missing `textAlign`.
          switcherEl.style.justifyContent = TEXT_ALIGN_TO_FLEX[switcher.textAlign || "left"];
          switcherEl.dataset.switcherIndex = i;
        });
      });
    }
  }, {
    key: "startSwitchers",
    value: function startSwitchers() {
      var _this3 = this;

      var animateIn = function animateIn(el) {
        var animationEndPromise = DOMUtils.animationEndPromise(el);
        el.classList.add("fade-in-enter-up");
        return animationEndPromise;
      };
      var animateOut = function animateOut(el) {
        var animationEndPromise = DOMUtils.animationEndPromise(el);
        el.classList.add("fade-out-exit-up");
        return animationEndPromise;
      };
      var switcherEls = this.el.querySelectorAll(".text-switcher");
      Array.from(switcherEls).forEach(function (switcherEl) {
        var currentReplacementIndex = 0;
        var replacementEls = Array.from(switcherEl.children);
        var animateNext = function animateNext() {
          if (!_this3.started) return;
          var nextIndex = (currentReplacementIndex + 1) % replacementEls.length;
          var exitingEl = replacementEls[currentReplacementIndex];
          var enteringEl = replacementEls[nextIndex];
          Promise.all([animateIn(enteringEl), animateOut(exitingEl)]).then(function () {
            if (!_this3.started) return;
            enteringEl.classList.remove("fade-in-enter-up");
            exitingEl.classList.remove("fade-out-exit-up");
            currentReplacementIndex = nextIndex;
            animateNext();
          });
        };
        animateNext();
      });
    }
  }, {
    key: "startTypingAnimation",
    value: function startTypingAnimation() {
      var _this4 = this;

      if (!this.typingEffect || !this.started) return;

      var textDOM = __WEBPACK_IMPORTED_MODULE_0__src_js_lib_text_anim__["c" /* getTextDom */](this.text);
      var textDOMLength = __WEBPACK_IMPORTED_MODULE_0__src_js_lib_text_anim__["a" /* domCountCharacters */](textDOM);

      var setTypingIndex = function setTypingIndex(index) {
        var textDOMSlice = __WEBPACK_IMPORTED_MODULE_0__src_js_lib_text_anim__["b" /* domSlice */](textDOM, index);
        __WEBPACK_IMPORTED_MODULE_0__src_js_lib_text_anim__["d" /* moveChildrenFromNode */](_this4.el, textDOMSlice.tree);
      };

      var animateTypingIndex = function animateTypingIndex(index) {
        // TODO(cory) If we change text animation so that letters appear in different ways (eg. sliding in),
        // we should animate the next letter by taking it as its own DOM slice, then animate that into the
        // correct location, then remove that slice in the next call to `setTypingIndex`.
        if (index <= textDOMLength) {
          setTypingIndex(index);
          setTimeout(function () {
            return animateTypingIndex(index + 1);
          }, TYPING_INTERVAL);
        } else if (_this4.repeatTypingEffect) {
          setTimeout(function () {
            return _this4.startTypingAnimation();
          }, REPEAT_TYPING_EFFECT_EVERY);
        }
      };

      setTypingIndex(0);
      setTimeout(function () {
        return animateTypingIndex(1);
      }, this.startTypingAfter);
    }
  }, {
    key: "load",
    value: function load() {}
  }, {
    key: "resize",
    value: function resize() {
      if (Utils.type(this.maxLines) === "number" && this.maxLines >= 1) {
        var nLines = Math.max(this.text.split("<br").length, this.maxLines);
        this.el.style.fontSize = DOMUtils.getFontSizeToFitLines(this.el, nLines) + "px";
      }
    }
  }, {
    key: "start",
    value: function start() {
      if (this.el) {
        this.started = true;
        this.el.classList.toggle("strafe", this.animation === "strafe");
        this.startSwitchers();
        this.startTypingAnimation();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.started = false;
      if (this.el) {
        this.el.classList.toggle("strafe", this.animation === "strafe");
      }
    }
  }, {
    key: "restart",
    value: function restart() {
      this.start();
    }
  }]);

  return Text;
}(Component));

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// text.js